import React from "react";
import { List, Datagrid, TextField, ShowButton } from "react-admin";


export const RoleList=(props)=>(
    <List {...props}>
        <Datagrid>
            <TextField source="name" label="Nombre del Rol"/>
            <TextField source="description" label="Description"/>
            <ShowButton/>
        </Datagrid>
    </List>
)